var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClodicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4824 24H7.51764C3.36601 24 0 20.6343 0 16.4831V7.51693C0 3.36569 3.36601 0 7.51764 0H16.4824C20.634 0 24 3.36569 24 7.51693V16.4808C24 20.6321 20.634 23.9977 16.4824 23.9977",
    fill: "#2F2F2F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.58587 5.41985H12.6132C14.7376 5.41985 16.3901 5.98193 17.5731 7.10834C18.756 8.23249 19.3475 9.86454 19.3475 11.9977C19.3475 14.1557 18.756 15.7923 17.5731 16.9052C16.3901 18.018 14.7353 18.5756 12.6132 18.5756H9.58587C9.45268 18.5914 9.31948 18.5575 9.21112 18.4808C9.13436 18.3724 9.1005 18.2393 9.1163 18.1061V5.89163C9.10275 5.76296 9.13662 5.63204 9.21112 5.52594C9.31722 5.44242 9.45268 5.40405 9.58587 5.42211M11.0646 16.9255H13.1009C14.5638 16.9255 15.6361 16.4966 16.3201 15.6366C17.0651 14.5824 17.4263 13.3047 17.3473 12.0158C17.3473 10.2054 16.8958 8.91646 15.9905 8.14897C14.9159 7.33181 13.575 6.94581 12.2317 7.06996H11.0646V16.9255Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.63968 9.94131H4.65078V11.93H6.63968V9.94131Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.70296 15.8465H4.71406V17.8352H6.70296V15.8465Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClodicon);
export default __webpack_public_path__ + "static/media/clodicon.042a05cc3ba84fcd926645ef5006214e.svg";
export { ForwardRef as ReactComponent };